import { render } from "./WorkdayPlusIcon.vue?vue&type=template&id=3b6399ae"
import script from "./WorkdayPlusIcon.vue?vue&type=script&lang=js"
export * from "./WorkdayPlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__